import { createApi } from '@reduxjs/toolkit/query/react';
import { POSITIONS_API } from 'services/constants';
import { rawBaseQuery } from 'services/shared';
import { PositionResponse, MappingsResponse } from 'services/types';

type PositionsParamsType = {
  selectedContext: string;
  selectedFund: string;
  positionType: string;
};

type MappingParamsType = {
  selectedContext: string;
};

export const positionsApi = createApi({
  reducerPath: POSITIONS_API,
  baseQuery: rawBaseQuery,
  endpoints: (builder) => ({
    getPositions: builder.query<PositionResponse[], PositionsParamsType>({
      query: ({ selectedContext, selectedFund, positionType }) =>
        encodeURI(
          `contexts/${selectedContext}/${positionType}/${selectedFund}/positions`
        ),
    }),
    getMappings: builder.query<MappingsResponse[], MappingParamsType>({
      query: ({ selectedContext }) =>
        encodeURI(`/contexts/${selectedContext}/portfolios`),
    }),
  }),
});

export const { useGetPositionsQuery, useGetMappingsQuery } = positionsApi;
